/** @format */
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "loginlayout",
    component: () => import("../views/LoginLayout.vue"),
    meta: { isPublic: true },
  },
  {
    path: "/otplayout",
    name: "otplayout",
    component: () => import("../views/OtpLayout.vue"),
    meta: { isPublic: true },
  },
  {
    path: "/forgotPassword",
    name: "forgotpassword",
    component: () => import("../views/ForgotPassword.vue"),
    meta: { isPublic: true },
  },
  {
    path: "/",
    component: () => import("../BaseLayout"),
    children: [
      { path: "/", redirect: "/meetings" },

      // ✅ Meetings & Contacts → accessible to all authenticated users
      {
        path: "/meetings",
        name: "menu.meetings",
        icon: "mdi-laptop",
        meta: { icon: "mdi-account-box" },
        component: () => import("../views/MeetingsLayout.vue"),
      },
      {
        path: "/contacts",
        name: "menu.contacts",
        icon: "mdi-account-box",
        meta: { icon: "mdi-account-box" },
        component: () => import("../views/ContactsLayout.vue"),
      },

      // ✅ Restricted modules → only role 1
      {
        path: "/user-management",
        name: "menu.userManagement",
        icon: "mdi-account",
        meta: { icon: "mdi-account", isRestricted: true },
        component: () => import("../views/UserManagementLayout.vue"),
      },
      {
        path: "/company",
        name: "menu.company",
        icon: "mdi-domain",
        meta: { icon: "mdi-domain", isRestricted: true },
        component: () => import("../views/CompanyLayout.vue"),
      },
      {
        path: "/department",
        name: "menu.department",
        icon: "mdi-domain",
        meta: { icon: "mdi-domain", isRestricted: true },
        component: () => import("../views/DepartmentLayout.vue"),
      },
      {
        path: "/location",
        name: "menu.location",
        icon: "mdi-map-marker-radius",
        meta: { icon: "mdi-map-marker-radius", isRestricted: true },
        component: () => import("../views/LocationLayout.vue"),
      },
      {
        path: "/reception",
        name: "menu.reception",
        icon: "mdi-desk",
        meta: { icon: "mdi-desk", isRestricted: true },
        component: () => import("../views/ReceptionLayout.vue"),
      },
      {
        path: "/general-settings",
        name: "menu.generalSettings",
        icon: "mdi-cog-transfer",
        meta: { icon: "mdi-cog-transfer", isRestricted: true },
        component: () => import("../views/GeneralSettingsLayout.vue"),
      },
      {
        path: "/email-settings",
        name: "menu.mailSettings",
        icon: "mdi-message-settings",
        meta: { icon: "mdi-message-settings", isRestricted: true },
        component: () => import("../views/EmailSettingsLayout.vue"),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "common.pageNotFound",
    component: () => import("../views/error/404"),
  },
  {
    path: "/access-denied",
    name: "403",
    component: () => import("../views/error/403"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("loginToken");
  // const userId = localStorage.getItem("userId");
  const loginSuccess = localStorage.getItem("loginSuccess");

  // ✅ Handle public routes
  if (to.matched.some((record) => record.meta.isPublic)) {
    // 🔹 Case 1: /login — if already fully logged in, redirect home
    if (to.path === "/login" && token) {
      return next({ path: "/" });
    }

    // 🔹 Case 2: /otplayout — only allow if userId exists (logged in but no token yet)
    if (to.path === "/otplayout") {
      if (!loginSuccess) {
        // No userId means not logged in yet → block
        return next({ path: "/login" });
      }

      // If token already exists, user already completed OTP → go to main page
      if (token) {
        return next({ path: "/" });
      }
    }

    // Public route (like forgot password)
    return next();
  }

  // ✅ For private routes (non-public)
  const tokenIsValid = await validateToken();
  if (!tokenIsValid) {
    // No token → redirect to login
    return next({ path: "/login", query: { redirect: to.fullPath } });
  }

  // ✅ Role check (for restricted routes)
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userRole = userDetails ? userDetails.role_type : null;

  const isRestrictedRoute = to.matched.some(
    (record) => record.meta.isRestricted
  );

  if (isRestrictedRoute && userRole !== 1) {
    console.log("User does not have permission for restricted route");
    return next({ path: "/access-denied" });
  }

  next();
});

async function validateToken() {
  return !!localStorage.getItem("loginToken");
}

export default router;
